export default "__VITE_ASSET__uLUHkjc0__"